import type { GetHeliosFilesListResponse, UploadHeliosFilesReq, UploadHeliosFilesResponse } from 'types/helios/files';
import { heliosApi } from '.';
import { TAG_TYPES } from 'types/services';

export const heliosFiles = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getHeliosFilesList: builder.query<GetHeliosFilesListResponse[], unknown>({
      query: ({ templateId, templateItemId, templateItemValue, recordId, entryId }) => {
        let url = 'Files?';
        const params = [];
        if (templateId) params.push(`templateId=${templateId}`);
        if (templateItemId) params.push(`templateItemId=${templateItemId}`);
        if (templateItemValue) params.push(`templateItemValue=${templateItemValue}`);
        if (recordId) params.push(`recordId=${recordId}`);
        if (entryId) params.push(`entryId=${entryId}`);
        url += params.join('&');
        return { url };
      },
      providesTags: [TAG_TYPES.FILES],
    }),
    uploadHeliosFiles: builder.mutation<UploadHeliosFilesResponse[], { payload: UploadHeliosFilesReq }>({
      query: ({ payload }) => ({
        url: 'Files',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: TAG_TYPES.FILES }],
    }),
  }),
});
export const { useGetHeliosFilesListQuery, useUploadHeliosFilesMutation } = heliosFiles;
